import { createAction } from '@reduxjs/toolkit';

export const logOutAction = createAction('auth/logOutAction');
